import React, { Fragment } from "react";
import ReactFullscreen from "react-full-screen";
import FadeIn from "react-fade-in";
import { translate } from "utlis/translations/i18n";

class GeneralResult extends React.Component {
  constructor() {
    super();
    this.state = { loaded: false, fullScreen: false };
  }

  render() {
    const { result, rank, maximum, resource, selectedName } = this.props;
    const { total } = result;
    const scores = (!selectedName || selectedName.trim() === "")
    ? result?.scores
    : result?.scores.filter(score => score.participantName === selectedName);
    
    return (
      <Fragment>
        {this.state.loaded ? null : (
          <div
            style={{
              height: "200vh",
              width: "400px",
            }}
          />
        )}
        <div
          className="col-xs-12 col-sm-6 col-lg-4"
          style={this.state.loaded ? {} : { display: "none" }}
        >
          <FadeIn>
            <div className="row pair-comparison-resume">
              <div className="col-xs-12 col-md-12 col-lg-12 no-p-l-r resource">
                <div className="resource">
                  {resource.type !== "VIDEO" && (
                    <ReactFullscreen enabled={this.state.fullScreen}>
                      <span className="helper-img"></span>
                      <img
                        className="img-responsive cursor-pointer img-center"
                        alt="Resource (Pair comparaison)"
                        src={resource.downloadURL}
                        onClick={() =>
                          this.setState({ fullScreen: !this.state.fullScreen })
                        }
                        onLoad={() => this.setState({ loaded: true })}
                      />
                    </ReactFullscreen>
                  )}
                  {resource.type === "VIDEO" && (
                    <video
                      className="img-responsive"
                      alt="Resource (Pair comparaison)"
                      src={resource.downloadURL}
                      controls
                      muted
                    />
                  )}
                </div>
              </div>
              <div className="col-xs-12 col-md-12 col-lg-12 infos">
                <div className="row">
                  <div className="col-xs-12 col-md-6 col-lg-6">
                    <div className="metadata">
                      <div className="label">Name</div>
                      <div className="value">{resource.name}</div>
                    </div>
                    <div className="metadata">
                      <div className="label">Points*</div>
                      <div className="value">{total}</div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6 col-lg-6">
                    <div className="metadata">
                      <div className="label">Position</div>
                      <div className="value">{rank}</div>
                    </div>
                    <div className="metadata">
                      <div className="label">Score**</div>
                      <div className="value">
                        {(total / maximum).toFixed(2)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {scores && scores.map((score, index) => (
  <div key={index} className="score-question-table">
    <div
      style={{
        borderRight: "1px solid white",
        width: "100%",
        minWidth: "100px",
      }}
    >
      {score?.participantName || translate('respondant')}
    </div>
    <div style={{ width: "100%", textAlign: "center" }}>{score?.score}</div>
  </div>
))}
          </FadeIn>
        </div>
      </Fragment>
    );
  }
}

export default GeneralResult;
